var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "o-wrapper u-m-t4 u-m-t3@s" }, [
    _c("div", { staticClass: "o-grid o-grid--center" }, [
      _vm.members.length !== 0
        ? _c(
            "div",
            { staticClass: "o-grid__item u-width-10/12 u-width-full@l" },
            [
              _c(
                "div",
                {
                  staticClass: "c-community__members",
                  attrs: { id: "vue-membersList" },
                },
                _vm._l(_vm.members, function (member) {
                  return _c("div", { staticClass: "c-community__member" }, [
                    _c("a", { attrs: { href: "/u/" + member.username } }, [
                      _c("div", [
                        _c("img", { attrs: { src: member.avatar } }),
                        _vm._v(" "),
                        _c("p", [_vm._v(_vm._s(member.name))]),
                      ]),
                      _vm._v(" "),
                      member.username
                        ? _c("span", [_vm._v("@" + _vm._s(member.username))])
                        : _vm._e(),
                    ]),
                  ])
                }),
                0
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showEmptyMessage
        ? _c(
            "div",
            {
              directives: [{ name: "else", rawName: "v-else" }],
              staticClass: "o-grid__item u-width-8/12 u-width-full@l",
            },
            [
              _vm.$root.user.username === _vm.$root.profile.username
                ? _c("div", { staticClass: "c-empty-state" }, [
                    _c("h4", [_vm._v(_vm._s(_vm.mineNoContentTitle))]),
                    _vm._v(" "),
                    _c("p", [_vm._v(_vm._s(_vm.mineNoContentMessage))]),
                    _vm._v(" "),
                    _c("a", { attrs: { href: "/search/people" } }, [
                      _c("img", {
                        attrs: {
                          src: _vm.$cdn("/img/avatar-default.svg"),
                          width: "100",
                          height: "100",
                          alt: "avatar",
                        },
                      }),
                    ]),
                  ])
                : _c("div", { staticClass: "c-empty-state" }, [
                    _c("h4", [_vm._v(_vm._s(_vm.theirNoContentTitle))]),
                    _vm._v(" "),
                    _c("p", [
                      _vm._v("As soon as they do they will be listed here."),
                    ]),
                    _vm._v(" "),
                    _c("a", { attrs: { href: "/search/people" } }, [
                      _c("img", {
                        attrs: {
                          src: _vm.$cdn("/img/avatar-default.svg"),
                          width: "100",
                          height: "100",
                          alt: "avatar",
                        },
                      }),
                    ]),
                  ]),
            ]
          )
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }